import { IContentViewModelProperty, IContentViewProperty } from '~/interfaces/contentViewInterfaces'
import ContentViewModelPropertyObjectModelProperty from '~/models/contentManagement/contentViewModelProperties/contentViewModelPropertyObjectModelProperty'
import ContentViewModelPropertyObjectModelRelation from '~/models/contentManagement/contentViewModelProperties/contentViewModelPropertyObjectModelRelation'

export default class ContentViewModelPropertyDefinition {
  /**
   * ModelProperty content element on ListViews have the ability to choose account relations in addition to the
   * already-standard object model properties.
   * However, choosing account relations _was_ unintentional but is now a feature.
   * Use +modelProperty+ as a common interface for ListViews to use when interacting with the chosen "property"
   * for a ModelProperty content element.
   */
  static modelProperty(property: IContentViewProperty): IContentViewModelProperty {
    if ('property_type' in property) {
      return new ContentViewModelPropertyObjectModelProperty(property)
    } else if ('relation_type' in property) {
      return new ContentViewModelPropertyObjectModelRelation(property)
    } else {
      return null
    }
  }
}
